import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, PagenameData, ContentDetailData } from './types'

export const selectContentListEvent = (state: RootState): Event => state.manageContentReducer.listEvent

export const selectContentList = (state: RootState): ListData => state.manageContentReducer.list

export const selectPagenameList = (state: RootState): PagenameData[] => state.manageContentReducer.pagenames

export const selectContentActionEvent = (state: RootState): Event => state.manageContentReducer.actionEvent

export const selectContentDetail = (state: RootState): ContentDetailData | undefined =>
  state.manageContentReducer.detail

export const selectContentDetailEvent = (state: RootState): Event => state.manageContentReducer.detailEvent
